import { Drawer as BlueprintDrawer, Classes, DrawerSize, } from "./externals";
import React from "react";
import "./Drawer.scss";
export { DrawerSize } from "@blueprintjs/core";
export const Drawer = ({ className, children, footer, onClose, isOpen, icon = "info-sign", isCloseButtonShown = true, size = DrawerSize.STANDARD, title = "Info", position, }) => {
    return (React.createElement(BlueprintDrawer, { className: className + " focusDrawer", icon: icon, onClose: onClose, title: title, isOpen: isOpen, isCloseButtonShown: isCloseButtonShown, size: size, position: position },
        React.createElement("div", { className: Classes.DRAWER_BODY + " focusDrawer__body" }, children),
        footer && (React.createElement("div", { className: Classes.DRAWER_FOOTER + " focusDrawer__footer" }, footer))));
};
//# sourceMappingURL=Drawer.js.map